

// import React from 'react';

// const Home = () => {
//   return (
//     <>
//       <section
//   style={{
//     position: 'relative',
//     textAlign: 'center',
//     padding: '40px 20px',
//     color: 'white',
//     width: '100%',
//     margin: '0 auto',
//   }}
// >
//   {/* Image */}
//   <img
//     src="https://tse1.mm.bing.net/th/id/OIP.gNrulNcAKjFRRowEzEfRHgHaEr?rs=1&pid=ImgDetMain&o=7&rm=3"
//     alt="Wedding Hall"
//     style={{
//       width: '100%',
//       height: 'auto',
//       borderRadius: '12px',
//       display: 'block',
//     }}
//   />


//   <div
//     style={{
//       position: 'absolute',
//       top: 0,
//       left: 0,
//       width: '100%',
//       height: '100%',
//       backgroundColor: 'rgba(128,128,128,0.5)', 
//       borderRadius: '12px',
//     }}
//   ></div>


//   <div
//     style={{
//       position: 'absolute',
//       top: 0,
//       left: 0,
//       width: '100%',
//       height: '100%',
//       display: 'flex',
//       flexDirection: 'column',
//       justifyContent: 'center',
//       alignItems: 'center',
//       padding: '0 20px',
//     }}
//   >
//     <h2 style={{ fontFamily: "'Great Vibes', cursive", fontSize: '38px',fontWeight:"800" ,marginBottom: '10px' }}>
//       Where your imagination becomes <br/>Reality...
//     </h2>
//     <p
//   style={{
//     fontSize: '18px',
//     fontWeight:'700',
//     maxWidth: '600px',
//     marginTop: '60px', 
//   }}
// >
//   Crimons is a premier event design and décor company offering design
//   services for weddings, corporate events, and private parties.
// </p>
//   </div>
// </section>
//     </>
//   );
// };

// export default Home;


// import React, { useEffect } from "react";
// import { useState } from "react";
// import emailjs from "@emailjs/browser";
// import { useRef } from "react";

// import { FaStar } from "react-icons/fa";
// import { Container, Form, Button } from "react-bootstrap";
// import { FaEnvelope, FaPhoneAlt, FaMapMarkerAlt } from "react-icons/fa";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "../../App.css"
// import "animate.css";
// import AOS from "aos";
// import { NavLink } from "react-router-dom";
// import "aos/dist/aos.css";


// const Home = () => {
//   const [hover, setHover] = useState(false);
//   const form = useRef();

// const sendEmail = (e) => {
//   e.preventDefault();

//   emailjs
//     .sendForm(
//       "service_t53zr2g",   // Service ID
//       "template_tocm6ei",  // Template ID
//       form.current,
//       "WfRm2rD0UdjNIh3Y6"  // Public Key
//     )
//     .then(
//       () => {
//         alert("Message sent successfully!");
//         form.current.reset();
//       },
//       (error) => {
//         console.log(error);
//         alert("Failed to send message");
//       }
//     );
// };
//   const images = [
//     "https://static.vecteezy.com/system/resources/thumbnails/030/837/537/small_2x/indian-wedding-decor-ideas-ai-generated-photo.jpg",
//     "https://th.bing.com/th/id/R.69e1378b0b72d49a7802392a72e87e1b?rik=g8No3Ym2gFuf%2fw&riu=http%3a%2f%2fwww.marriagecolours.com%2fwp-content%2fuploads%2f2025%2f04%2fBhavya-Arvind-Wedding-MRC-17.jpg&ehk=x4TdrzhsG078fAHWUKecArSIyKsxTMCVXWguIOSfuuw%3d&risl=&pid=ImgRaw&r=0",
//     "https://getethnic.com/wp-content/uploads/2020/09/207007-AmitaSPhotography-0084-orig.jpg",
//     "https://img.freepik.com/premium-photo/stage-with-stage-with-flowers-stage-with-stage-with-large-stage-with-large-stage-wit_865967-1019439.jpg",
//     "https://www.grandweddings.co.in/wp-content/uploads/2020/03/indian-wedding-stage-decoration-photos-magnificent-portrait-7-1170x777.jpg",
//     "https://edenweddingplanner.com/wp-content/uploads/2024/12/A1674CFA-86C5-4671-A0A1-3DADDFCAE101-1024x634.jpeg",
//   ];
  
// useEffect(() => {
//   AOS.init({
//     duration: 800,
//     once: false      
//   });
// }, []);


// const testimonials = [
//   {
//     name: "Priya Sharma",
//     role: "Bride",
//     text: "sangam mairrage hall made our wedding day magical! The decor was stunning and the staff was incredibly helpful.",
//     image: "https://randomuser.me/api/portraits/women/79.jpg",
//   },
//   {
//     name: "Rahul Verma",
//     role: "Groom",
//     text: "We couldn't have asked for a better venue. The team at Eternal Vows took care of everything!",
//     image: "https://randomuser.me/api/portraits/men/75.jpg",
//   },
//   {
//     name: "Ananya Gupta",
//     role: "Bride",
//     text: "Our wedding at Sangam Mairrage hall was a dream come true. The ambiance was perfect and our guests loved it.",
//     image: "https://randomuser.me/api/portraits/women/72.jpg",
//   },
//   {
//     name: "Amit Singh",
//     role: "Groom",
//     text: "From the planning to the big day, everything was seamless. Highly recommend Eternal Vows!",
//     image: "https://randomuser.me/api/portraits/men/76.jpg",
//   },
//   {
//     name: "Neha Kapoor",
//     role: "Bride",
//     text: "The attention to detail at Eternal Vows is unmatched. Our wedding was everything we hoped for and more!",
//     image: "https://randomuser.me/api/portraits/women/71.jpg",
//   },
//   {
//     name: "Rohit Malhotra",
//     role: "Groom",
//     text: "Sangam Mairrage hall provided us with an unforgettable experience. The venue was beautiful and the service was top-notch.",
//     image: "https://randomuser.me/api/portraits/men/78.jpg",
//   },
// ];

//   return (
//     <>

//     <div
//         style={{
//           minHeight: "100vh",
//           backgroundImage: `
//   linear-gradient(rgba(0,0,0,0.75), rgba(0,0,0,0.75)),
//   url("https://www.happywedding.app/blog/wp-content/uploads/2023/03/Wedding-Stage-Decor.jpg")
// `,
//           backgroundSize: "cover",
//           backgroundPosition: "center",
//           color: "white",
//         }}
//       >
//         <Container
//           className="d-flex flex-column justify-content-center align-items-center text-center"
//           style={{ minHeight: "100vh" }}
//         >
//           {/* <h1 style={{ fontSize: "4rem" }}>
//             Celebrate Your <br />
//             <span style={{ color: "#ff3b1f" }}>
//               Dream Wedding
//             </span>
//           </h1> */}

//           <h1 style={{ fontSize: "4rem", fontWeight: "700" }}>
//   Celebrate Your <br />

//   <span
//     style={{
//       color: "#ff3b1f",
//       position: "relative",
//       display: "inline-block",
//     }}
//   >
//     Dream Wedding

//     <span
//       className="animated-line"
//       style={{
//         position: "absolute",
//         left: 0,
//         bottom: "-8px",
//         height: "4px",
//         width: "100%",
//         background: "#ff3b1f",
//         borderRadius: "10px",
//       }}
//     ></span>
//   </span>
// </h1>
// <p
//   style={{
//     maxWidth: "750px",
//     margin: "20px auto",
//     textAlign: "center",
//     lineHeight: "1.8",
//     fontSize: "20px",
//     color: "white",
//   }}
// >
//   {/* Welcome to Sangam Mairrage Hall, where elegance meets romance.
//   Our stunning <br/>venue is designed to create unforgettable memories
//   for your special day.<br/> Let us help you turn your wedding dreams
//   into reality. */}
//   Welcome to Sangam Marriage Hall, the ideal destination for weddings, birthdays, and grand celebrations.
// Our beautifully designed venue offers the perfect setting for every occasion.<br/>
// From joyful gatherings to elegant events, we make every moment truly special.<br/>
// Celebrate your important days with us in style.
// </p>
//           <div className="d-flex gap-3 mt-4">
//             <NavLink to="/services" style={{ textDecoration: "none" }}>
//   <Button style={{ background: "#ff3b1f", border: "none" }}>
//     View Services
//   </Button>
// </NavLink>
//             {/* <Button variant="outline-light">
//               Contact Us
//             </Button> */}
//           </div>
//         </Container>
//       </div>

//     <section style={{ background: "#efefef", padding: "70px 0"}}>
//   <Container>
//     <div className="row align-items-center">
//       <div className="col-lg-6 col-md-12 mb-4">
//         <p
//           style={{
//             fontSize: "1rem",
//             lineHeight: "1.8",
//             color: "#333",
//             marginBottom: "40px",
//             maxWidth: "520px",
//           }}
//         >
//           Welcome to Sangam Mairrage Hall, your newest destination for creating beautiful and memorable weddings. Launched in 2026, we bring fresh ideas, personalized service, and modern decor to make your special day truly unforgettable.
//         </p>

//         <div className="row g-4">
//           <div className="col-6">
//             <h3 style={{ fontWeight: "700", color: "#000" }}>
//               Innovative Designs
//             </h3>
//             <p style={{ color: "#444", lineHeight: "1.6" }}>
//               We craft creative and unique wedding setups tailored to your style.
//             </p>
//           </div>

//           <div className="col-6">
//             <h3 style={{ fontWeight: "700", color: "#000" }}>
//               Personalized Service
//             </h3>
//             <p style={{ color: "#444", lineHeight: "1.6" }}>
//               Every couple receives customized attention for a seamless experience.
//             </p>
//           </div>

//           <div className="col-6">
//             <h3 style={{ fontWeight: "700", color: "#000" }}>
//               Modern Approach
//             </h3>
//             <p style={{ color: "#444", lineHeight: "1.6" }}>
//               We combine contemporary trends with timeless elegance for every event.
//             </p>
//           </div>

//           <div className="col-6">
//             <h3 style={{ fontWeight: "700", color: "#000" }}>
//               Dedicated Team
//             </h3>
//             <p style={{ color: "#444", lineHeight: "1.6" }}>
//               Passionate coordinators and designers committed to perfection.
//             </p>
//           </div>
//         </div>
//       </div>

//       <div className="col-lg-6 col-md-12 text-center">
//         <img
//           src="https://images.unsplash.com/photo-1519167758481-83f550bb49b3?q=80&w=1200&auto=format&fit=crop"
//           alt="Wedding Hall"
//           className="img-fluid"
//           style={{
//             borderRadius: "4px",
//             width: "100%",
//             maxWidth: "600px",
//             objectFit: "cover",
//           }}
//         />
//       </div>
//     </div>
//   </Container>
// </section>
//       <section
//         style={{
//           background: "#000",
//           color: "#fff",
//           padding: "80px 0",
//         }}
//       >
//         <Container>
//           <div className="row mb-5">
//             <div className="col-md-4">
//               <h2
//                 style={{
//                   fontWeight: 700,
//                   fontSize: "2rem",
//                   lineHeight: 1.2,
//                 }}
//               >
//                 Our Exclusive Wedding Services
//               </h2>
//             </div>

//             <div className="col-md-8">
//               <p style={{ lineHeight: 1.8, color: "#ddd" }}>
//                 At Sangam Mairrage Hall, we offer a range of services to make your
//                 wedding day unforgettable. From meticulous planning to stunning
//                 decor, our team is dedicated to bringing your vision to life.
//               </p>

//               <div className="row mt-3">
//                 <div className="col-sm-6">
//                   <h5 style={{ fontWeight: 700 }}>Wedding Planning</h5>
//                   <p
//                     style={{
//                       color: "#bbb",
//                       fontSize: "0.95rem",
//                     }}
//                   >
//                     Our expert planners ensure every detail is perfect.
//                   </p>
//                 </div>

//                 <div className="col-sm-6">
//                   <h5 style={{ fontWeight: 700 }}>Decor Options</h5>
//                   <p
//                     style={{
//                       color: "#bbb",
//                       fontSize: "0.95rem",
//                     }}
//                   >
//                     Choose from elegant themes and custom decor.
//                   </p>
//                 </div>
//               </div>
//             </div>
//           </div>

//           <div className="text-center mb-4">
//             <h3 style={{ fontWeight: 700 }}>Wedding Moments</h3>
//             <p style={{ color: "#bbb" }}>
//               Explore our stunning gallery of unforgettable weddings at Sangam Mairrage Hall.
//             </p>
//           </div>
// <div
//   style={{
//     display: "grid",
//     gridTemplateColumns: "repeat(3, 1fr)",
//     gap: "12px",
//   }}
// >
//   {images.map((img, index) => (
//     <div
//       key={index}
//       data-aos="fade-up"
//       data-aos-delay={index * 100}
//       style={{
//         width: "100%",
//         aspectRatio: "1 / 1",
//         overflow: "hidden",
//         borderRadius: "8px",
//         background: "#111",
//       }}
//     >
//       <img
//         src={img}
//         alt={`Wedding ${index + 1}`}
//         style={{
//           width: "100%",
//           height: "100%",
//           objectFit: "cover",
//           display: "block",
//         }}
//       />
//     </div>
//   ))}
// </div>
//  </Container>

//       </section>

      
//        <section style={{ background: "#ececec", padding: "70px 0" }}>
//       <Container>
//    <div className="row g-4">
//   {testimonials.map((item, index) => (
//     <div className="col-md-4 col-sm-6 d-flex" key={index}>
//       <div
//         className="w-100 d-flex flex-column justify-content-between"
//         style={{
//           background: "#000",
//           color: "#fff",
//           padding: "20px",
//           borderRadius: "4px",
//           minHeight: "220px",
//         }}
//       >
//         <div>
//           <div className="mb-3 text-warning">
//             {[...Array(5)].map((_, i) => (
//               <FaStar key={i} className="me-1" />
//             ))}
//           </div>

//           <p style={{ fontSize: "14px", lineHeight: "1.6" }}>
//             {item.text}
//           </p>
//         </div>

//         <div className="d-flex align-items-center mt-3">
//           <img
//             src={item.image}
//             alt={item.name}
//             style={{
//               width: "40px",
//               height: "40px",
//               borderRadius: "50%",
//               objectFit: "cover",
//               marginRight: "10px",
//             }}
//           />
//           <div>
//             <h6 className="mb-0 fw-bold">{item.name}</h6>
//             <small>{item.role}</small>
//           </div>
//         </div>
//       </div>
//     </div>
//   ))}
// </div>
//       </Container>
//     </section>
//      <section style={{ background: "#FFFFFF", padding: "80px 0" }}>
//       <Container>
//         <div className="row">
//   <div className="col-md-5 mb-4">
//     <h2 className="fw-bold mb-3">Get in Touch</h2>
//     <p className="text-muted mb-4">
//       We'd love to hear from you! Reach out today.
//     </p>

    
//     <div className="mb-3 d-flex align-items-center"> 
//       <FaEnvelope className="me-2" />
//       <span>sangamguesthouse2026@gmail.com</span>
//     </div>


//     <div className="mb-3 d-flex align-items-center">
//       <FaPhoneAlt className="me-2" />
//       <span>8882062122, 9450609827</span>
//     </div>


//     <div className="mb-3 d-flex align-items-center">
//       <FaMapMarkerAlt className="me-2" />
//       <span>
//         39, Mahuwari, Hanswahini road, Near ITI factory, Naini, Prayagraj, Uttar Pradesh
//       </span>
//     </div>
//   </div>

//           <div className="col-md-7">
//          <Form ref={form} onSubmit={sendEmail}>
//               <Form.Group className="mb-3">
//                 <Form.Label>Name</Form.Label>
//                 <Form.Control type="text" name="user_name" placeholder="Enter your name" required />
//               </Form.Group>

//               <Form.Group className="mb-3">
//                 <Form.Label>Email</Form.Label>
//                 <Form.Control type="email" name="user_email" placeholder="Enter your email" required/>
//               </Form.Group>

//               <Form.Group className="mb-3">
//                 <Form.Label>Message</Form.Label>
//               <Form.Control as="textarea" rows={4} name="message" placeholder="Type your message" required/>
//               </Form.Group>

//               <Form.Group className="mb-3">
//                 <Form.Check
//                   type="checkbox"
//                   label="I accept the Terms"
//                 />
//               </Form.Group>

//               {/* <Button
//                 style={{
//                   background: "#ff3b1f",
//                   border: "none",
//                   padding: "10px 28px",
//                 }}
//               >
//                 Submit
//               </Button> */}
// <Button
//   type="submit"
//   style={{
//     background: hover ? "#ff6a4d" : "#ff3b1f",
//     border: "none",
//     padding: "10px 28px",
//     color: "#fff",
//     transition: "0.3s ease",
//   }}
//   onMouseEnter={() => setHover(true)}
//   onMouseLeave={() => setHover(false)}
// >
//   Submit
// </Button>
//             </Form>
//           </div>
//         </div>
//       </Container>
//     </section>
//     </>
//   );
// };

// export default Home;

import React, { useEffect, useState, useRef } from "react";
import emailjs from "@emailjs/browser";
import { FaStar, FaEnvelope, FaPhoneAlt, FaMapMarkerAlt } from "react-icons/fa";
import { Container, Form, Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../App.css";
import "animate.css";
import AOS from "aos";
import { NavLink } from "react-router-dom";
import "aos/dist/aos.css";
import image from "../../Images/image.jpg"

const Home = () => {
  const [hover, setHover] = useState(false);
    const [isHover, setIsHover] = useState(false);
    const [isChecked, setIsChecked] = useState(false);
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();
      if (!isChecked) {
    alert("Please accept the Terms before submitting.");
    return;
  }

    emailjs
      .sendForm(
        "service_t53zr2g",
        "template_tocm6ei",
        form.current,
        "WfRm2rD0UdjNIh3Y6"
      )
      .then(
        () => {
          alert("Message sent successfully!");
          form.current.reset();
        },
        (error) => {
          console.log(error);
          alert("Failed to send message");
        }
      );
  };

  const images = [
    "https://static.vecteezy.com/system/resources/thumbnails/030/837/537/small_2x/indian-wedding-decor-ideas-ai-generated-photo.jpg",
    "https://th.bing.com/th/id/R.69e1378b0b72d49a7802392a72e87e1b?rik=g8No3Ym2gFuf%2fw&riu=http%3a%2f%2fwww.marriagecolours.com%2fwp-content%2fuploads%2f2025%2f04%2fBhavya-Arvind-Wedding-MRC-17.jpg&ehk=x4TdrzhsG078fAHWUKecArSIyKsxTMCVXWguIOSfuuw%3d&risl=&pid=ImgRaw&r=0",
    "https://getethnic.com/wp-content/uploads/2020/09/207007-AmitaSPhotography-0084-orig.jpg",
    "https://img.freepik.com/premium-photo/stage-with-stage-with-flowers-stage-with-stage-with-large-stage-with-large-stage-wit_865967-1019439.jpg",
    "https://www.grandweddings.co.in/wp-content/uploads/2020/03/indian-wedding-stage-decoration-photos-magnificent-portrait-7-1170x777.jpg",
    "https://edenweddingplanner.com/wp-content/uploads/2024/12/A1674CFA-86C5-4671-A0A1-3DADDFCAE101-1024x634.jpeg",
  ];

  useEffect(() => {
    AOS.init({
      duration: 800,
      once: false,
    });
  }, []);

  const testimonials = [
    {
      name: "Priya Sharma",
      role: "Bride",
      text: "Sangam Guest House and Marriage Lawn made our wedding day magical! The decor was stunning and the staff was incredibly helpful.",
      image: "https://randomuser.me/api/portraits/women/79.jpg",
    },
    {
      name: "Rahul Verma",
      role: "Groom",
      text: "We couldn't have asked for a better venue. The team at Sangam Guest House and Marriage Lawn took care of everything!",
      image: "https://randomuser.me/api/portraits/men/75.jpg",
    },
    {
      name: "Ananya Gupta",
      role: "Bride",
      text: "Our wedding at Sangam Guest House and Marriage Lawn was a dream come true.",
      image: "https://randomuser.me/api/portraits/women/72.jpg",
    },
    {
      name: "Amit Singh",
      role: "Groom",
      text: "Everything was seamless.",
      image: "https://randomuser.me/api/portraits/men/76.jpg",
    },
    {
      name: "Neha Kapoor",
      role: "Bride",
      text: "The attention to detail is unmatched.",
      image: "https://randomuser.me/api/portraits/women/71.jpg",
    },
    {
      name: "Rohit Malhotra",
      role: "Groom",
      text: "Beautiful venue and top-notch service.",
      image: "https://randomuser.me/api/portraits/men/78.jpg",
    },
  ];

  return (
    <>
      <div
        style={{
          minHeight: "100vh",
          backgroundImage: `
            linear-gradient(rgba(0,0,0,0.75), rgba(0,0,0,0.75)),
            url("https://www.happywedding.app/blog/wp-content/uploads/2023/03/Wedding-Stage-Decor.jpg")
          `,
          backgroundSize: "cover",
          backgroundPosition: "center",
          color: "white",
        }}
      >
        <Container
          className="d-flex flex-column justify-content-center align-items-center text-center"
          style={{ minHeight: "100vh" }}
        >
          <h1
            style={{
              fontSize: "clamp(2rem, 6vw, 4rem)",
              fontWeight: "700",
              lineHeight: "1.2",
              padding: "0 10px",
            }}
          >
            Celebrate Your <br />
            <span
              style={{
                color: "#ff3b1f",
                position: "relative",
                display: "inline-block",
              }}
            >
              Dream Wedding
              <span
                className="animated-line"
                style={{
                  position: "absolute",
                  left: 0,
                  bottom: "-8px",
                  height: "4px",
                  width: "100%",
                  background: "#ff3b1f",
                  borderRadius: "10px",
                }}
              ></span>
            </span>
          </h1>

          <p
            style={{
              maxWidth: "750px",
              margin: "20px auto",
              textAlign: "center",
              lineHeight: "1.8",
              fontSize: "clamp(16px, 2vw, 20px)",
              color: "white",
              padding: "0 10px",
            }}
          >
            Welcome to  Sangam Guest House and Marriage Lawn, the ideal destination for weddings,
            birthdays, and grand celebrations.
            <br />
            Our beautifully designed venue offers the perfect setting for every
            occasion.
            <br />
            From joyful gatherings to elegant events, we make every moment truly
            special.
          </p>

          <div className="d-flex gap-3 mt-4">
            <NavLink to="/services" style={{ textDecoration: "none" }}>
              {/* <Button style={{ background: "#ff3b1f", border: "none" }}>
                View Services
              </Button> */}
              <Button
      style={{
        backgroundColor: isHover ? "#ff6a4d" : "#ff3b1f",
        border: "none",
        transition: "0.3s ease"
      }}
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
    >
      View Services
    </Button>
            </NavLink>
          </div>
        </Container>
      </div>

        <section style={{ background: "#efefef", padding: "70px 0"}}>
  <Container>
    <div className="row align-items-center">
      <div className="col-lg-6 col-md-12 mb-4">
        <p
          style={{
            fontSize: "1rem",
            lineHeight: "1.8",
            color: "#333",
            marginBottom: "40px",
            maxWidth: "520px",
          }}
        >
          Welcome to  Sangam Guest House and Marriage Lawn, your newest destination for creating beautiful and memorable weddings. Launched in 2026, we bring fresh ideas, personalized service, and modern decor to make your special day truly unforgettable.
        </p>

        <div className="row g-4">
          <div className="col-6">
            <h3 style={{ fontWeight: "700", color: "#000" }}>
              Innovative Designs
            </h3>
            <p style={{ color: "#444", lineHeight: "1.6" }}>
              We craft creative and unique wedding setups tailored to your style.
            </p>
          </div>

          <div className="col-6">
            <h3 style={{ fontWeight: "700", color: "#000" }}>
              Personalized Service
            </h3>
            <p style={{ color: "#444", lineHeight: "1.6" }}>
              Every couple receives customized attention for a seamless experience.
            </p>
          </div>

          <div className="col-6">
            <h3 style={{ fontWeight: "700", color: "#000" }}>
              Modern Approach
            </h3>
            <p style={{ color: "#444", lineHeight: "1.6" }}>
              We combine contemporary trends with timeless elegance for every event.
            </p>
          </div>

          <div className="col-6">
            <h3 style={{ fontWeight: "700", color: "#000" }}>
              Dedicated Team
            </h3>
            <p style={{ color: "#444", lineHeight: "1.6" }}>
              Passionate coordinators and designers committed to perfection.
            </p>
          </div>
        </div>
      </div>

      <div className="col-lg-6 col-md-12 text-center">
        <img
          src={image}
          alt="Wedding Hall"
          className="img-fluid"
          style={{
            borderRadius: "4px",
            width: "100%",
            maxWidth: "600px",
            objectFit: "cover",
          }}
        />
      </div>
    </div>
  </Container>
</section>
   <section
        style={{
          background: "#000",
          color: "#fff",
          padding: "80px 0",
        }}
      >
        <Container>
          <div className="row mb-5">
            <div className="col-md-4">
              <h2
                style={{
                  fontWeight: 700,
                  fontSize: "2rem",
                  lineHeight: 1.2,
                }}
              >
                Our Exclusive Wedding Services
              </h2>
            </div>

            <div className="col-md-8">
              <p style={{ lineHeight: 1.8, color: "#ddd" }}>
                At Sangam Guest House and Marriage Lawn, we offer a range of services to make your
                wedding day unforgettable. From meticulous planning to stunning
                decor, our team is dedicated to bringing your vision to life.
              </p>

              <div className="row mt-3">
                <div className="col-sm-6">
                  <h5 style={{ fontWeight: 700 }}>Wedding Planning</h5>
                  <p
                    style={{
                      color: "#bbb",
                      fontSize: "0.95rem",
                    }}
                  >
                    Our expert planners ensure every detail is perfect.
                  </p>
                </div>

                <div className="col-sm-6">
                  <h5 style={{ fontWeight: 700 }}>Decor Options</h5>
                  <p
                    style={{
                      color: "#bbb",
                      fontSize: "0.95rem",
                    }}
                  >
                    Choose from elegant themes and custom decor.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="text-center mb-4">
            <h3 style={{ fontWeight: 700 }}>Wedding Moments</h3>
            <p style={{ color: "#bbb" }}>
              Explore our stunning gallery of unforgettable weddings at Sangam Guest House and Marriage Lawn.
            </p>
          </div>
<div
  style={{
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: "12px",
  }}
>
  {images.map((img, index) => (
    <div
      key={index}
      data-aos="fade-up"
      data-aos-delay={index * 100}
      style={{
        width: "100%",
        aspectRatio: "1 / 1",
        overflow: "hidden",
        borderRadius: "8px",
        background: "#111",
      }}
    >
      <img
        src={img}
        alt={`Wedding ${index + 1}`}
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          display: "block",
        }}
      />
    </div>
  ))}
</div>
 </Container>

      </section>
    
       <section style={{ background: "#ececec", padding: "70px 0" }}>
      <Container>
   <div className="row g-4">
  {testimonials.map((item, index) => (
    <div className="col-md-4 col-sm-6 d-flex" key={index}>
      <div
        className="w-100 d-flex flex-column justify-content-between"
        style={{
          background: "#000",
          color: "#fff",
          padding: "20px",
          borderRadius: "4px",
          minHeight: "220px",
        }}
      >
        <div>
          <div className="mb-3 text-warning">
            {[...Array(5)].map((_, i) => (
              <FaStar key={i} className="me-1" />
            ))}
          </div>

          <p style={{ fontSize: "14px", lineHeight: "1.6" }}>
            {item.text}
          </p>
        </div>

        <div className="d-flex align-items-center mt-3">
          <img
            src={item.image}
            alt={item.name}
            style={{
              width: "40px",
              height: "40px",
              borderRadius: "50%",
              objectFit: "cover",
              marginRight: "10px",
            }}
          />
          <div>
            <h6 className="mb-0 fw-bold">{item.name}</h6>
            <small>{item.role}</small>
          </div>
        </div>
      </div>
    </div>
  ))}
</div>
      </Container>
    </section>
 <section style={{ background: "#FFFFFF", padding: "80px 0" }}>
      <Container>
        <div className="row">
  <div className="col-md-5 mb-4">
    <h2 className="fw-bold mb-3">Get in Touch</h2>
    <p className="text-muted mb-4">
      We'd love to hear from you! Reach out today.
    </p>

    
    <div className="mb-3 d-flex align-items-center"> 
      <FaEnvelope className="me-2" />
      <span>sangamguesthouse2026@gmail.com</span>
    </div>


    <div className="mb-3 d-flex align-items-center">
      <FaPhoneAlt className="me-2" />
      <span>8882062122, 9450609827</span>
    </div>


    <div className="mb-3 d-flex align-items-center">
      <FaMapMarkerAlt className="me-2" />
      <span>
        39, Mahuwari, Hanswahini road, Near ITI factory, Naini, Prayagraj, Uttar Pradesh-211010
      </span>
    </div>
  </div>

          <div className="col-md-7">
         <Form ref={form} onSubmit={sendEmail}>
              <Form.Group className="mb-3">
                <Form.Label>Name</Form.Label>
                <Form.Control type="text" name="user_name" placeholder="Enter your name" required />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Email</Form.Label>
                <Form.Control type="email" name="user_email" placeholder="Enter your email" required/>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Message</Form.Label>
              <Form.Control as="textarea" rows={4} name="message" placeholder="Type your message" required/>
              </Form.Group>

              {/* <Form.Group className="mb-3">
                <Form.Check
                  type="checkbox"
                  label="I accept the Terms"
                />
              </Form.Group> */}
              <Form.Group className="mb-3">
  <Form.Check
    type="checkbox"
    label="I accept the Terms"
    checked={isChecked}
    onChange={(e) => setIsChecked(e.target.checked)}
    required
  />
</Form.Group>

              {/* <Button
                style={{
                  background: "#ff3b1f",
                  border: "none",
                  padding: "10px 28px",
                }}
              >
                Submit
              </Button> */}
<Button
  type="submit"
  style={{
    background: hover ? "#ff6a4d" : "#ff3b1f",
    border: "none",
    padding: "10px 28px",
    color: "#fff",
    transition: "0.3s ease",
  }}
  onMouseEnter={() => setHover(true)}
  onMouseLeave={() => setHover(false)}
>
  Submit
</Button>
            </Form>
          </div>
        </div>
      </Container>
    </section>

    </>
  );
};

export default Home;